module.exports = __webpack_public_path__ + "assets/img/happy-customers.5d2f1f89.svg";